// Version : 0.0.1
// Author : AGALYA

import GoldLoanProposalActionTypes from './gold-loan-proposal.types';

/** ***************** GET GOLD LOAN PROPOSAL START ***************** */
export const getGoldLoanProposalStart = (getData: any) => ({
	type: GoldLoanProposalActionTypes.GET_GOLD_LOAN_PROPOSAL_START,
	payload: getData,
});

export const getGoldLoanProposalSuccess = (successData: any) => ({
	type: GoldLoanProposalActionTypes.GET_GOLD_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const getGoldLoanProposalFailure = (failureData: any) => ({
	type: GoldLoanProposalActionTypes.GET_GOLD_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const getGoldLoanProposalResponseReset = () => ({
	type: GoldLoanProposalActionTypes.GET_GOLD_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const getGoldLoanProposalListResponseChanged = () => ({
	type: GoldLoanProposalActionTypes.GET_GOLD_LOAN_PROPOSAL_RESPONSE_CHANGED,
});

/** ***************** GET GOLD LOAN PROPOSAL END ************ */

/** ***************** FETCH GOLD LOAN PROPOSAL START ********** */
export const fetchGoldLoanProposalStart = (fetchData: any) => ({
	type: GoldLoanProposalActionTypes.FETCH_GOLD_LOAN_PROPOSAL_START,
	payload: fetchData,
});

export const fetchGoldLoanProposalSuccess = (successData: any) => ({
	type: GoldLoanProposalActionTypes.FETCH_GOLD_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const fetchGoldLoanProposalFailure = (failureData: any) => ({
	type: GoldLoanProposalActionTypes.FETCH_GOLD_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const fetchGoldLoanProposalResponseResetStart = () => ({
	type: GoldLoanProposalActionTypes.FETCH_GOLD_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const fetchGoldLoanProposalResponseChanged = () => ({
	type: GoldLoanProposalActionTypes.FETCH_GOLD_LOAN_PROPOSAL_RESPONSE_CHANGED,
});

/** ******************* FETCH GOLD LOAN PROPOSAL END ****************** */

/** ***************** DELETE GOLd LOAN PROPOSAL START *********************** */
export const deleteLoanProposalStart = (deleteData: any) => ({
	type: GoldLoanProposalActionTypes.DELETE_LOAN_PROPOSAL_START,
	payload: deleteData,
});

export const deleteLoanProposalSuccess = (successData: any) => ({
	type: GoldLoanProposalActionTypes.DELETE_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const deleteLoanProposalFailure = (failureData: any) => ({
	type: GoldLoanProposalActionTypes.DELETE_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const deleteLoanProposalResponseReset = () => ({
	type: GoldLoanProposalActionTypes.DELETE_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const deleteLoanProposalResponseChanged = () => ({
	type: GoldLoanProposalActionTypes.DELETE_LOAN_PROPOSAL_RESPONSE_CHANGED,
});

/** ***************** DELETE GOLD LOAN PROPOSAL END *********************** */

/** ****************** UPDATE GOLD LOAN PROPOSAL START ********************* */

export const updateLoanProposalStart = (deleteData: any) => ({
	type: GoldLoanProposalActionTypes.UPDATE_LOAN_PROPOSAL_START,
	payload: deleteData,
});

export const updateLoanProposalSuccess = (successData: any) => ({
	type: GoldLoanProposalActionTypes.UPDATE_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const updateLoanProposalFailure = (failureData: any) => ({
	type: GoldLoanProposalActionTypes.UPDATE_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const updateLoanProposalResponseReset = () => ({
	type: GoldLoanProposalActionTypes.UPDATE_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const updateLoanProposalResponseChanged = () => ({
	type: GoldLoanProposalActionTypes.UPDATE_LOAN_PROPOSAL_RESPONSE_CHANGED,
});

/** ***************** UPDATE GOLD LOAN PROPOSAL END ******************* */

/** ***************** CREATE GOLD LOAN PROPOSAL START *********************** */

export const addGoldLoanProposalStart = (addData: any) => ({
	type: GoldLoanProposalActionTypes.ADD_GOLD_LOAN_PROPOSAL_START,
	payload: addData,
});

export const addGoldLoanProposalSuccess = (successData: any) => ({
	type: GoldLoanProposalActionTypes.ADD_GOLD_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const addGoldLoanProposalFailure = (failureData: any) => ({
	type: GoldLoanProposalActionTypes.ADD_GOLD_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const addGoldLoanProposalResponseResetStart = () => ({
	type: GoldLoanProposalActionTypes.ADD_GOLD_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const addGoldLoanProposalResponseChanged = () => ({
	type: GoldLoanProposalActionTypes.ADD_GOLD_LOAN_PROPOSAL_RESPONSE_CHANGED,
});

/** ***************** CREATE GOLD LOAN PROPOSAL END *********************** */

/** ***************** APPROVE GOLD LOAN PROPOSAL ***************** */
export const approveLoanProposalStart = (getData: any) => ({
	type: GoldLoanProposalActionTypes.APPROVE_LOAN_PROPOSAL_START,
	payload: getData,
});

export const approveLoanProposalSuccess = (successData: any) => ({
	type: GoldLoanProposalActionTypes.APPROVE_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const approveLoanProposalFailure = (failureData: any) => ({
	type: GoldLoanProposalActionTypes.APPROVE_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const approveLoanProposalResponseReset = () => ({
	type: GoldLoanProposalActionTypes.APPROVE_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const approveLoanProposalResponseChanged = () => ({
	type: GoldLoanProposalActionTypes.APPROVE_LOAN_PROPOSAL_RESPONSE_CHANGED,
});

/** ***************** APPROVE GOLD LOAN PROPOSAL END ************ */

/** ***************** REVERT GOLD LOAN PROPOSAL ***************** */
export const revertLoanProposalStart = (getData: any) => ({
	type: GoldLoanProposalActionTypes.REVERT_LOAN_PROPOSAL_START,
	payload: getData,
});

export const revertLoanProposalSuccess = (successData: any) => ({
	type: GoldLoanProposalActionTypes.REVERT_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const revertLoanProposalFailure = (failureData: any) => ({
	type: GoldLoanProposalActionTypes.REVERT_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const revertLoanProposalResponseReset = () => ({
	type: GoldLoanProposalActionTypes.REVERT_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const revertLoanProposalResponseChanged = () => ({
	type: GoldLoanProposalActionTypes.REVERT_LOAN_PROPOSAL_RESPONSE_CHANGED,
});

/** ***************** REVERT GOLD LOAN PROPOSAL END ************ */

/** ***************** GET SEARCH GOLD LOAN MEMBER START ***************** */
export const getSearchGoldLoanMemberStart = (getData: any) => ({
	type: GoldLoanProposalActionTypes.GET_SEARCH_GOLD_LOAN_MEMBER_START,
	payload: getData,
});

export const getSearchGoldLoanMemberSuccess = (successData: any) => ({
	type: GoldLoanProposalActionTypes.GET_SEARCH_GOLD_LOAN_MEMBER_SUCCESS,
	payload: successData,
});

export const getSearchGoldLoanMemberFailure = (failureData: any) => ({
	type: GoldLoanProposalActionTypes.GET_SEARCH_GOLD_LOAN_MEMBER_FAILURE,
	payload: failureData,
});

export const getSearchGoldLoanMemberResponseReset = () => ({
	type: GoldLoanProposalActionTypes.GET_SEARCH_GOLD_LOAN_MEMBER_RESPONSE_RESET,
});

export const getSearchGoldLoanMemberResponseChanged = () => ({
	type: GoldLoanProposalActionTypes.GET_SEARCH_GOLD_LOAN_MEMBER_RESPONSE_CHANGED,
});

/** ***************** GET SEARCH GOLD LOAN MEMBER END ************ */
